import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import ContainerDefault from '../../components/ContainerDefault';
import { Loading } from '../../components/UtilComponent';
import * as balancaAction from '../../services/balanca/Action';
import * as codeAction from '../../services/code/Action';
import * as Constants from '../../utils/constants';
import FormCode from './components/FormCode';


class CodeContainer extends Component {
    intervalo = null;
    constructor() {
        super();
        this.handleSave = this.handleSave.bind(this);

    }
    componentDidMount() {
        const { action } = this.props;
        this.intervalo =  setInterval(function () {
            action.getLeituraAction();
        }, 4000);
    }
    handleCancel() {
        console.log('sair');
    }

    clearMessage(tempo) {

        setTimeout(function () { //Start the timer
            this.props.action.clearAction();
        }.bind(this), tempo)


    }

    componentWillUnmount() {
        clearInterval(this.intervalo);
    }
    handleSave(values) {
        return this.props.action.readerCodeAction(values).then((codeObject) => {
            this.clearMessage(10000)
        }).catch((error) => {
            this.clearMessage(6000)
            throw new SubmissionError(error);

        });

        // window.print();
    }
    retornarDadosTela() {
        const { codeObject, messages, messageSuccess, isLoading } = this.props;


        if (isLoading) return (
            <Loading title={Constants.DESCRICAO_READER_CODE} />
        );
        return (<ContainerDefault
            title={Constants.DESCRICAO_READER_CODE}
            messages={messages}
            messageSuccess={messageSuccess}
            container={
                <FormCode
                    handleSave={this.handleSave}
                    handleCancel={this.handleCancel}
                    heading={'Ler código de barras'}
                />
            } />);

    }

    render() {
        return this.retornarDadosTela();
    }

}
const mapStateToProps = state => ({
    codeObject: state.codeReducer.codeObject,
    messages: state.messageResponseReducer.messages,
    messageSuccess: state.messageResponseReducer.messageSuccess,
    isLoading: state.apiReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({
    action: bindActionCreators({ ...codeAction, ...balancaAction }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(CodeContainer);